import { useMemo } from 'react';
import { BubblesProps } from './props';
import { circles } from './circles';
import styles from './styles.module.scss';

export default function Bubbles({ color }: BubblesProps) {
  const max = 60;
  const min = 30;

  const Circles = useMemo(
    () =>
      circles.map((c, idx) => {
        const getRandomTranslate = (isOdd: boolean) => {
          const random = Math.floor(Math.random() * (max - min + 1) + min);

          if (isOdd) {
            return random * -1;
          }

          return random;
        };

        return (
          <circle
            className={styles.container__circle}
            style={{
              //@ts-ignore
              '--data-bubbles-translate-value': `${getRandomTranslate(
                idx % 2 != 0,
              )}%`,
              fill: color,
            }}
            cx={c.cx}
            cy={c.cy}
            r={c.r}
            key={`circle-${c.cx}`}
          />
        );
      }),
    [color],
  );

  return (
    <div className={styles.container}>
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1080 484"
      >
        {Circles}
      </svg>
    </div>
  );
}
